import { useEffect } from 'react'
import { Title } from './helper/DocumentTitle'

export default function Download() {
  const pageName = 'دانلود اپلیکیشن اردبیل من'
  Title(pageName)

  useEffect(() => {
    document.querySelector('header span').innerText = pageName
  }, [])

  return (
    <section style={{ paddingTop: '2rem' }}>
      <ul>
        <li>
          <button>
            <a href="https://cafebazaar.ir/app/co.median.android.mryowa" target={`_blank`}>
              دانلود مستقیم اپلیکشن اردبیل من
            </a>
          </button>
        </li>
      </ul>
    </section>
  )
}
